import { render, staticRenderFns } from "./CoverInpainting.vue?vue&type=template&id=73afb9ad&scoped=true&"
import script from "./CoverInpainting.vue?vue&type=script&lang=js&"
export * from "./CoverInpainting.vue?vue&type=script&lang=js&"
import style0 from "./CoverInpainting.vue?vue&type=style&index=0&id=73afb9ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73afb9ad",
  null
  
)

export default component.exports